import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
// import { connect } from "react-redux";
import Tabs from "@material-ui/core/Tabs";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../style";

const styles = theme => ({
  bigIndicator: {
    height: 2,
    backgroundColor: "#00bc84"
  },
  activeTab: {
    color: "#00bc84 !important",
    fontWeight: "bold"
  },
  Tabs: {
    fontWeight: "bold"
  }
});

class SubMenu extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tabValue: props.activeTabValue ? props.activeTabValue : ""
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      tabValue: props.activeTabValue ? props.activeTabValue : ""
    });
  }

  render() {
    const { tabsVisible, menuName, classes } = this.props;
    const { tabValue } = this.state;
    return (
      <div className="submenu">
        <h2 className="mainHeading">{menuName}</h2>
        <Tabs
          textColor="primary"
          classes={{ indicator: classes.bigIndicator }}
          value={tabValue}
          variant="scrollable"
        >
          {tabsVisible &&
            tabsVisible.map((data, index) => {
              return (
                <Tab
                  key={index}
                  className={classes.Tabs}
                  label={data.TabName}
                  value={data.value}
                  component={Link}
                  to={data.link}
                  className={
                    tabValue === data.value ? classes.activeTab : classes.Tabs
                  }
                />
              );
            })}
        </Tabs>
      </div>
    );
  }
}
export default withStyles(styles)(SubMenu);



// WEBPACK FOOTER //
// ./src/components/private/SubMenu.js